export const SECTION_BLOCK_NAME = 'Section'
export const COLUMN_BLOCK_NAME = 'Column'
export const POST_COMPOSER_BLOCK_NAME = 'PostComposer'
